module.exports = __webpack_public_path__ + "media/images/noavatar-fe1e3893b278b7eb704aab8c2c84f839.jpg";